import { apiUrl, get } from "./HttpClient";

const controllerPrefix = `${apiUrl}/Categories`;

export default {
    getCategory: (categoryId, token) => {
        if (!categoryId) {
            return get(`${controllerPrefix}`, token);
        } else {
            return get(
                `${controllerPrefix}?parentCategoryId=${categoryId}`,
                token
            );
        }
    }
};
